import styled from "styled-components";
import { colors } from "../../../../theme/color";
import fipayFonts from "../../../../theme/index";

export const UserProfileMain = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 10px;
  box-shadow: 0px 4px 4px 0px #eaeaea40;
  @media screen and (max-width: 767px) {
  }
`;

export const UserProfileHeader = styled.div`
  padding: 20px;
  width: 96%;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e8eaed;
  @media screen and (max-width: 767px) {
    flex-direction: column;
    gap: 1rem;
  }
`;

export const UserProfileSubHeader = styled.div`
  width: 90%;
  display: flex;
  align-items: center;
  flex-direction: flex-start;
  // border:2px solid blue;
`;

export const UserProfileSpan = styled.span`
  font-weight: 500;
  font-size: 18px;
  color: ${colors.NAVYBLUE};
`;

export const UserProfileSearch = styled.div`
  position: relative;
  display: flex;
  height: 40px;
  box-sizing: border-box;
  padding: 12px 38px 12px 15px;
  align-items: center;
  border-radius: 10px;
  // border:2px solid red;
  padding-left: 30px;
  width: 55%;
`;

export const StyledInput = styled.input`
  width: 100%;
  padding-left: 40px;
  height: 40px;
  position: absolute;
  background-color: transparent;
  outline: none;
  font-size: 12px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  box-sizing: border-box;
`;

export const SearchIconStyled = styled.img`
  flex-shrink: 0;
  z-index: 1;
  cursor: pointer;
  padding-left: 10px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;

  &:hover {
    color: ${colors.ButtonBackgroundColors.primaryMediumHoverButton};
    &::after {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

export const UserProfileFilter = styled.div`
  /* width: 10%;
  display: flex;
  margin: 0 auto; */
  // border:2px solid red;
`;

export const UserProfileFilterButton = styled.button`
  width: 10%;
  background: #ffffff;
  border: 1px solid #e8eaed;
  border-radius: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 767px) {
    width: 40%;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
  }
`;

export const UserProfileActivityTable = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &::-webkit-scrollbar {
    display: none;
  }

  @media screen and (max-width: 767px) {
    overflow-x: auto;
    white-space: nowrap;
    gap: 5rem;
  }
`;

export const UserProfileActivityTypes = styled.div`
  display: flex;
  justify-content: space-between;
  width: 35%;
  padding-left: 30px;
  font-weight: 400;
  font-size: 14px;
  color: #666464;
  @media screen and (max-width: 767px) {
    width: auto;
    gap: 2rem;
  }
`;

export const UserProfileActivityCalenderTime = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: ${colors.NEUTRAL_GREY};
  padding-right: 30px;
  display: flex;
  align-items: center;
  //  border: 2px solid red;
`;

export const UserProfileActivityTime = styled.span`
  padding-left: 10px;
  color: ${colors.NEUTRAL_NEUTRAL};
`;

export const UserProfileTitles = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0px;
  background: #f7f7f7;
  border: 1px solid #e8eaed;
  font-weight: 400;
  font-size: 12px;
  color: ${colors.NEUTRAL_NEUTRAL};
  width: 100%;
`;

export const UserProfileTitleName = styled.span`
  width: 30%;
  padding: 0px 0px 0px 20px;
  color: #afafaf;
`;

export const UserProfileTitleRole = styled.span`
  color: #afafaf;
`;

export const UserProfileTitleStatus = styled.span`
  color: #afafaf;
`;

export const UserProfileTitleLast = styled.span`
  color: #afafaf;
`;

export const UserProfileTitleAction = styled.span`
  padding: 0px 20px 0px 0px;
  color: #afafaf;
`;

export const UserProfileEmptyDashboard = styled.div`
  padding: 70px 0px;
`;

//user Profile Styles

export const ProfileContentcon = styled.div`
  /* padding: 20px; */
`;

export const ProfileDetailsCon = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  border: 2px solid blue;
`;

export const ProfileInfocon = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckboxCon = styled.div``;

export const ProfileImgCon = styled.div`
  display: flex;
`;

export const ProfileNameEmailCon = styled.div`
  width: 50%;
  /* overflow: scroll;
  -webkit-overflow-scrolling: touch; */
  @media screen and (max-width: 767px) {
    width: 45%;
  }
`;

export const ProfileName = styled.h3`
  margin: 0;
  padding: 0;
  font-weight: 500;
  font-size: 14px;
`;

export const ProfileEmail = styled.p`
  margin: 0;
  padding: 0;
  font-weight: 400;
  font-size: 12px;
  color: #afafaf;
  word-wrap: break-word;

  @media screen and (max-width: 767px) {
    width: 90%;
  }
`;

export const ProfileUserType = styled.div`
  width: 50%;
  margin: 0 auto;
  border-radius: 5px;
  border: 1px solid #e8eaed;
  padding: 8px 10px;
  font-size: 14px;
`;

export const ProfileUserTypeSpan = styled.span`
  font-weight: 400;
  font-size: 14px;
`;

export const ProfileStatusCon = styled.div`
  width: 15%;
  padding: 10px 0px;
  display: flex;
  justify-content: center;
`;

export const ProfileTiming = styled.div`
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ProfileTimingSpan = styled.span`
  font-weight: 500;
  font-size: 14px;
`;

export const ProfileTimingSubSpan = styled.span`
  font-weight: 400;
  font-size: 14px;
  padding-left: 10px;
  color: #868686;
`;

export const Status = styled.span<{ $active?: boolean }>`
  color: ${({ $active }) => ($active ? `${colors.GREEN}` : "#666464")};
  font-weight: ${({ $active }) => ($active ? "700" : "")};
  border-bottom: 2px solid
    ${({ $active }) => ($active ? `${colors.GREEN}` : "transparent")};
  padding: 20px 0px;
`;

export const StyledSelect = styled.select`
  width: auto;
  padding: 8px;
  border: 1px solid #e8eaed;
  border-radius: 0.5rem;
  font-size: 16px;
  font-family: "Gt Walsheim Pro", sans-serif;
  background-color: transparent;
  outline: none;
  &:focus {
  }
`;

export const Option = styled.option``;

//Edit User Modal

export const EditUserModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20000;
  backdrop-filter: blur(2px);
`;

export const EditUserModalContainer = styled.div`
  width: 40%;
  overflow-y: scroll;
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;

  @media screen and (max-width: 1024px) {
    width: 60%;
  }

  @media screen and (max-width: 768px) {
    width: 90%;
    max-height: 90vh;
  }
`;

export const EditUserModalHeader = styled.div`
  height: 115px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${colors.PRIMARY_GREY};
`;

export const EditUserBigText = styled.h4`
  font-weight: 700;
  font-size: 18px;
  line-height: 32px;
  margin: 0;
  padding: 0;
`;

export const EditUserSubText = styled.h4`
  font-weight: 400;
  font-size: 14px;
  color: #8c8b8b;
  margin: 0;
  padding: 0;
`;

export const EditUserCloseButton = styled.button`
  background-color: ${colors.White};
  border: none;
  font-size: 18px;
  // cursor: pointer;
  margin-right: 30px;
  border: 1px solid #e8eaed;
  border-radius: 50%;
  padding: 4px;
  width: 30px;
  height: 30px;
`;

export const EditPhoneBox = styled.span`
  width: 90%;
  padding-left: 10px;
  color: ${colors.BLACK};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

export const EditPhoneContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  padding-left: 15px;
  padding-top: 4px;
`;

export const Label = styled.label`
  padding-left: 17px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
`;

export const EditSmallInput = styled.input`
  height: 30px;
  text-indent: 10px;
  padding: 8px;
  width: 10%;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  margin-left: 1px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  position: relative;
  color: #0e0e0e;
  font-family: "Gt Walsheim Pro", sans-serif;

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

export const EditLargeInput = styled.input`
  height: 30px;
  text-indent: 10px;
  padding: 8px;
  margin-left: 8px;
  width: 76%;
  border: 1px solid #f0f2f4;
  border-radius: 15px;
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body2};
  position: relative;
  color: #0e0e0e;
  font-family: "Gt Walsheim Pro", sans-serif;

  -moz-appearance: textfield;

  &:focus {
    outline: none;
    border-color: #322b76;
    background-color: #e9eaf9;
  }
`;

export const EditModalButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  height: 70px;
  margin-top: 70px;

  @media screen and (max-width: 768px) {
    margin-top: 15px;
    margin-left: 2px;
  }
`;

export const EditButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 30%;
  margin-right: 30px;
`;

export const EditButtonContainer1 = styled.div`
  display: flex;
  justify-content: center;
  width: 20%;
  margin-right: 30px;
`;
